import { Proposal, ProposalId, VotingOption } from './Proposal'

export const sampleProposal = (): Proposal => {
  return {
    id: 'proposal-id' as ProposalId,
    title: 'Proposal title as presented in official AGM documentation',
    formattedDescription:
      'A **Markdown** formatted description of the proposal, as presented in *official* AGM documentation',
    votingOptions: [VotingOption.For, VotingOption.Against, VotingOption.Abstain],
  }
}
